<template>
  <div>
    <!-- :get-form-data="fromData" -->
    <list
      row-key="DpId"
      ref="list"
      unit="部门管理"
      :expand-all-row="true"
      :page="page"
      :show-checkbox="true"
      :show-query="false"
      :query-params="params"
      :get-data-func="api.list"
      urlHash="basedata/personnel/dp"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="table">
        <slot name="column"></slot>
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from "@/mixins/trend/list";
import list from "@/components/common/trendsTable/list";
export default {
  mixins: [listMixin],
  components: { list },
  data() {
    return {
      api: require("@/api/ent/dp").default,
      params: {
        DpNo: "",
        DpName: "",
        EmpId: null,
        Status: 1,
      },
    };
  },
  props: {
    showTrendTable: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    onExport() {
      var loading = this.$loading({
        lock: true,
        text: "正在导出...",
        spinner: "el-icon-loading",
        customClass: "my_loading",
        background: "rgba(0, 0, 0, 0.3)",
      });

      this.api.export({}).then(() => {
        loading.close();
      });
    },
    delRange(ids) {
      this.api.delete({ ids }).then((res) => {
        if (res.Code == 0) {
          this.$message.success("删除成功");
          this.reload();
          this.$refs.list.$parent.$parent.$refs.type_tree.getData()
          console.log(this.$refs,this.$refs.list.$parent);
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
  },
};
</script>
